import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AppBar,
  Toolbar,
  makeStyles,
  Badge,
  Box,
  IconButton,
  Menu,
  Card,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { ThemeContext } from '../../App';
import { Link } from "react-router-dom";
import NotificationsIcon from "@material-ui/icons/Notifications";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import history from "../../utils/HistoryUtils";
import axios from "axios";
import Config from "../../../src/config/config";
import LoadingComponent from "../Loading/Loading";
import Notification from "../Notification/Notification";
import { notificationClear } from "../../store/action/notificationMsg";
import { getNotification, readNotification } from "../../store/action";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Brightness4, Brightness7 } from "@material-ui/icons";
import WbSunnySharpIcon from '@material-ui/icons/WbSunnySharp';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    background: "transparent",
    boxShadow: "none",
    color: "#000",
    position: "sticky",
    top: 0,
    marginBottom: 0,
  },
  rootBox: {
    backgroundColor: theme.palette.background.main,
    padding: "0px 24px",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    color: theme.palette.listItem,
    flexGrow: 1,
    textTransform: "capitalize",
    fontWeight: 500,
  },
  menuBox: {
    "& .MuiMenu-list": {
      padding: 0,
      minWidth: 175,
      minHeight: "28px",
    },
    "& .MuiListItem-root": {
      borderBottom: "1px solid #dcdcdc",
      // width: 300,
      minWidth: 190,
      maxWidth: 350,
      "&:last-child": {
        borderBottom: "none",
      },
    },
    "& .active": {
      backgroundColor: "#f78b46",
      color: "#fff",
      pointerEvent: "none",
      cursor: "default",
    },
  },
  menuHeading: {
    fontSize: 15,
  },
  menuDesc: {
    fontSize: 13,
    whiteSpace: "normal",
    color: "rgba(0, 0, 0, 0.7)",
    "&.isRead": {
      fontWeight: "500",
      color: "#000",
    },
  },
}));

const Navbar = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [notificationShow, setNotificationShow] = React.useState(null);
  const { status } = useSelector((state) => state.loadingReducer);
  const { notificationList } = useSelector((state) => state.notificationList);
  const loadingStatus = status ? true : false;
  var notificationInfo = useSelector((state) => state.notificationMsg);
  const location = useLocation();
  const open = Boolean(anchorEl);
  const open1 = Boolean(notificationShow);
  const loggedUser = localStorage.getItem("role").replace(/['"]+/g, "");
  let unReadNotification;

  // const titleName = window.location.pathname.split("/").pop();
  const titleName = window.location.pathname?.split("/admin/")[1]?.split("/")[0]

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuNotification = (event) => {
    setNotificationShow(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setNotificationShow(null);
  };

  const openProfile = () => {
    // const loggedUser = localStorage.getItem("role").replace(/['"]+/g, '');
    if (loggedUser === "ORGANIZATION") {
      history.push("/admin/organization-profile");
    } else if (loggedUser === "SUPERADMIN") {
      history.push("/super-admin/profile");
    } else {
      history.push("/staff/staff-profile");
    }
    handleClose();
  };

  const logout = () => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    axios
      .get(`${Config.API_URL}api/organization/logout`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${loggedInUser}`,
        },
      })
      .then((response) => {
        localStorage.clear();
        history.push("/login");
      })
      .catch((error) => {
        localStorage.clear();
        history.push("/login");
      });
  };

  const clearNotificationMsg = () => {
    let reqParam = { message: null, status: null, type: null };
    setTimeout(() => {
      dispatch(notificationClear(reqParam));
    }, 4000);
  };

  useEffect(() => {
    dispatch(getNotification(1));
  }, []);

  if (loggedUser == "ORGANIZATION") {
    unReadNotification =
      notificationList?.data &&
      notificationList?.data.filter((val) => val.is_read == 0).length;
  } else {
    unReadNotification =
      notificationList?.data &&
      notificationList?.data.filter((val) => val.is_staff_read == 0).length;
  }

  const readNotification1 = (e, val) => {
    e.preventDefault();
    const requestData = {
      notification_id: val.id,
      is_read: true,
      signee_id: val.signee_id,
    };
    dispatch(readNotification(requestData)).then(() => {
      // this promise has been added because when update notification process is done then redirect process will start
      if (val.message.includes("You had been mention by chat by") && val?.url != null) {
        window.location.href = val?.url;
      }
    }
    );


  };
  const ReadAllNotification = () => {
    const requestData = {
      notification_id: "All",
      is_read: true,
    };
    dispatch(readNotification(requestData));
  };
  const loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
  const { mode, toggleTheme } = useContext(ThemeContext); // ✅ access context values

  return (
    <>
      {/* common notification */}
      {notificationInfo?.message && (
        <>
          <Notification
            data={notificationInfo?.message}
            status={notificationInfo?.status ? "success" : "error"}
          />
          {clearNotificationMsg()}
        </>
      )}
      {/* common notification */}

      {/* loading */}
      {loadingStatus && <LoadingComponent status={loadingStatus} />}
      {/* loading */}

      <AppBar position="static" className={classes.root}>
        <Box className={classes.rootBox}>
          <Card
            style={{
              marginTop: 4,
              marginBottom: 8,
              display: "flex",
              justifyContent: "space-between",
              color: "#02294F",
              alignItems: "center",
              background: "none",
              boxShadow: "none",
            }}
          >
            {loginUserInfo.role === "ORGANIZATION" ? (
              titleName === "compliance-document" ? (
                <Typography variant="h5" className={classes.title} color="primary" >Compliance Document</Typography>
              ) : titleName === "umbrella-company" ? (
                <Typography variant="h5" className={classes.title} color="primary" >Umbrella Companies</Typography>
              ) : titleName === "compliance-category" ? (
                <Typography variant="h5" className={classes.title} color="primary" >Compliance Category</Typography>
              ) : titleName === "payment-scheme" ? (
                <Typography variant="h5" className={classes.title} color="primary" >Payment Schemes</Typography>
              ) : titleName === "systemlogs" ? (
                <Typography variant="h5" className={classes.title} color="primary" >System Logs</Typography>
              ) : titleName === "invoice-studio" ? (
                <Typography variant="h5" className={classes.title} color="primary" >Invoicing Studio</Typography>
              ) : titleName === "detail" ? (
                <Typography variant="h5" className={classes.title} color="primary" >Payment Scheme</Typography>
              ) : (
                <Typography variant="h5" className={classes.title} color="primary" >
                  {titleName !== "invoice-studio" &&
                    titleName !== "detail" &&
                    titleName !== "changepassword" &&
                    titleName}
                </Typography>
              )
            ) : titleName === "staff-profile" ? (
              <Typography variant="h5" className={classes.title} color="primary" >Staff Profile</Typography>
            ) : titleName === "payment-scheme" ? (
              <Typography variant="h5" className={classes.title} color="primary" >Payment Scheme</Typography>
            ) : titleName === "candidate" ? (
              <Typography variant="h5" className={classes.title} color="primary" >Candidates</Typography>
            ) : titleName == "detail" ? (
              <Typography variant="h5" className={classes.title} color="primary" >Detail</Typography>
            ) : (
              <Typography variant="h5" className={classes.title} color="primary" >{titleName}</Typography>
            )}

            <Box display="flex" justifyContent="flex-end">
              <IconButton color="inherit" onClick={toggleTheme}>
                {mode === "light" ? <Brightness4 style={{ color: "#000" }} /> : <WbSunnySharpIcon style={{ color: "#eeeeee" }} />}
              </IconButton>
              <IconButton color="inherit" onClick={handleMenuNotification}>
                <Badge badgeContent={unReadNotification} color="secondary">
                  <NotificationsIcon color="primary" />
                </Badge>
              </IconButton>

              <Menu
                anchorEl={notificationShow}
                open={open1}
                onClose={handleClose}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                className={classes.menuBox}
              >
                {notificationList?.data && notificationList?.data.length > 0 ? (
                  notificationList?.data.map((val, index) => {
                    if (index < 5) {
                      return (
                        <MenuItem
                          onClick={(e) => readNotification1(e, val)}

                          style={{
                            background:
                              (loggedUser === "ORGANIZATION" ? val.is_read : val.is_staff_read) == 0
                                ? "#e7f2ff"
                                : "white",
                          }}
                          key={index}
                        >
                          <div>
                            <Typography
                              variant="body2"
                              className={`${classes.menuDesc} ${(loggedUser === "ORGANIZATION" ? val.is_read : val.is_staff_read) === 0 ? "isRead" : ""
                                }`}
                            >
                              {val.message}
                            </Typography>

                          </div>
                        </MenuItem>
                      );
                    }
                  })
                ) : (
                  <MenuItem>
                    <div>
                      <Typography variant="h6" className={classes.menuHeading}>
                        No Data Found{" "}
                      </Typography>
                    </div>
                  </MenuItem>
                )}
                {notificationList?.data && notificationList?.data.length > 0 ? (
                  <MenuItem>
                    <>
                      <Link to="/admin/notification">
                        <Typography variant="caption">
                          Show all notification
                        </Typography>
                      </Link>
                      <span
                        style={{ marginLeft: "auto" }}
                        onClick={ReadAllNotification}
                      >
                        <Typography variant="caption">Read all</Typography>
                      </span>
                    </>
                  </MenuItem>
                ) : (
                  ""
                )}
              </Menu>

              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <AccountCircleIcon color="primary" />
              </IconButton>

              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                open={open}
                onClose={handleClose}
              >
                <MenuItem onClick={openProfile}>Profile</MenuItem>
                <MenuItem onClick={logout}>Logout</MenuItem>
              </Menu>
            </Box>
          </Card>
        </Box>
      </AppBar>
    </>
  );
};

export default Navbar;
